import React, { Component } from 'react';
import styled from 'styled-components';

import MenuButton from '../../MenuButton';
import MobileMenuContent from './MobileMenuContent';

class MenuMobile extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        const { onClick = null } = this.props;

        if (onClick !== null) {
            // const style = event.target.getBoundingClientRect();
            const props = {
                // left: style.left,
                // top: style.top,
                left: event.clientX,
                top: event.clientY,
                onClick,
            };

            onClick(MobileMenuContent, props);
        }
    }

    render() {
        const { className } = this.props;

        return (
            <Root className={className} onClick={(event) => this.handleClick(event)}>
                <MenuButton />
            </Root>
        );
    }
}

const Root = styled.div``;

export default MenuMobile;
